import React, { useEffect, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import SnackbarComponent from '../Snackbar/index'
import copyIcon from './images/copyIcon.svg'
import rectangleXmark from './images/rectangle-xmark.svg'
import styles from './styles.module.css' // Assuming you have a CSS module with the required styles
import {
  propertyLinks,
  businessLinks,
  peopleLinks,
  productLinks
} from './ApiLinks'
import useEscapeKey from '../utils/useEscapeKey'

function ModalApiCall ({ onClose, queryStore, isQueryLoading, dataType }) {
  const [snackMessage, setSnackMessage] = useState({ type: 'error' })
  const [isVisible, setIsVisible] = useState(false)
  const query = queryStore?.query

  // Function to handle backdrop click
  const handleBackdropClick = event => {
    if (event.target === event.currentTarget) {
      setIsVisible(false)
      setTimeout(() => {
        onClose()
      }, 250)
    }
  }

  const handleClose = () => {
    setIsVisible(false)
    setTimeout(() => {
      onClose()
    }, 250)
  }

  useEscapeKey(handleClose)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsVisible(true)
    }, 1)

    return () => clearTimeout(timeoutId)
  }, [])

  useEffect(() => {
    if (isQueryLoading) {
      handleClose()
    }
  }, [isQueryLoading]) /* eslint-disable-line react-hooks/exhaustive-deps */

  function escapeQuotesInQueryProperty (query) {
    const complexValueRegex =
      /(mostRecentStatus|propertyType|hvacTypes|exteriorFeatures|roofing|address|city|province|postalCode|country|county|people.name|people.title):\((".*?"\s*(OR\s*".*?")*)\)/g
    const simpleValueRegex =
      /(mostRecentStatus|propertyType|hvacTypes|exteriorFeatures|roofing|address|city|neighborhoods|province|postalCode|country|county|lotSizeUnit|floorSizeUnit|features.key|features.value|descriptions.value|people.name|people.title):"(.*?)"/g

    let result = query.replace(complexValueRegex, match => {
      return match.replace(/"/g, '\\"')
    })

    result = result.replace(simpleValueRegex, match => {
      return match.replace(/"/g, '\\"')
    })

    return result
  }

  function escapeQuotesInQuery (query) {
    return query.replace(/"/g, '\\"')
  }

  const escapedQuery =
    // || dataType === 'product'
    dataType === 'property'
      ? escapeQuotesInQueryProperty(query)
      : escapeQuotesInQuery(query)

  const apiCallText = `{"query": "${escapedQuery}" }`

  return (
    <div className={styles.modalBackdrop} onClick={handleBackdropClick}>
      <div
        className={styles.modalContent}
        style={{ transform: isVisible ? 'translateX(0)' : 'translateX(100%)' }}
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          <h2 className={styles.ApiCallTitle}>View API call</h2>
          <div className={styles.closeButtonContainer}>
            <span className={styles.closeButtonTitle} onClick={handleClose}>
              Close
            </span>
            <img
              onClick={handleClose}
              src={rectangleXmark}
              alt='rectangleXmarkIcon'
              className={styles.rectangleIcon}
            />
          </div>
        </div>
        <hr style={{ border: '1px solid #E5E5E5', margin: '0px -40px' }} />
        <div className={styles.apiCallContainer}>
          <span className={styles.ApiCallSmallTitle}>API call</span>
          <div className={styles.containerQuery}>
            <span className={styles.apiCallTextBracket}>{'{'}</span>
            <span className={styles.apiCallKey}>"query"</span>
            <span className={styles.apiCallText}>: </span>
            <span className={styles.apiCallValue}>"{escapedQuery}"</span>
            <span className={styles.apiCallTextBracket}>{'}'}</span>
          </div>
        </div>
        <div className={styles.copyContainer}>
          <CopyToClipboard
            text={apiCallText}
            onCopy={() =>
              setSnackMessage({
                type: 'success',
                myMessage: 'Query copied',
                update: Date.now()
              })
            }
          >
            <span className={styles.copyButton}>Copy</span>
          </CopyToClipboard>
          <CopyToClipboard
            text={apiCallText}
            onCopy={() =>
              setSnackMessage({
                type: 'success',
                myMessage: 'Query copied',
                update: Date.now()
              })
            }
          >
            <img src={copyIcon} alt='copyIcon' className={styles.copyIcon} />
          </CopyToClipboard>
        </div>
        <hr style={{ border: '1px solid #E5E5E5', margin: '0px -40px' }} />
        <div className={styles.documentationContainer}>
          <h3 className={styles.documentationTitle}>Documentation</h3>
          {dataType === 'property'
            ? propertyLinks
            : dataType === 'business'
            ? businessLinks
            : dataType === 'people'
            ? peopleLinks
            : productLinks}
        </div>
      </div>
      <SnackbarComponent snackData={snackMessage} />
    </div>
  )
}

export default ModalApiCall
